import useCart from '@hooks/cart/useCart';
import useShop from '@hooks/shop/useShop';
import { cartActions } from '@store/cart/cartSlice';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

function usePrepareWithCart(shopId: string) {
    const { cart } = useCart(shopId);
    const shop = useShop(shopId);
    const dispatch = useDispatch();

    useEffect(() => {
        if (shop) {
            if (cart) {
                dispatch(cartActions.prepareWithCart({
                    shop,
                    cart,
                }));
            } else {
                dispatch(cartActions.resetCart(shop));
            }
        }
    }, [cart, shop]);
}

export default usePrepareWithCart;
